import { render, staticRenderFns } from "./DeleteProductModal.vue?vue&type=template&id=231c14cc&scoped=true&"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c14cc",
  null
  
)

export default component.exports